import Button from '@atoms/Button/Button';
import useTranslations from '@hooks/useTranslations';
import CloseButton from '@molecules/CloseButton/CloseButton';
import Modal from '@molecules/Modal/Modal';
import clsx from 'clsx';
import { PropsWithChildren } from 'react';

import styles from './FilterModal.module.scss';

interface Props {
  id: string;
  isOpen: boolean;
  onClose: () => void;
  onClear: () => void;
}

export default function FilterModal({
  id,
  isOpen,
  onClose,
  onClear,
  children,
}: PropsWithChildren<Props>) {
  const t = useTranslations();

  return (
    <Modal
      id={id}
      isOpen={isOpen}
      onClose={onClose}
      isPanel
      modalClassName={styles.modal}
    >
      <header className={clsx(styles.header, 'u-container-width')}>
        <h2 className={styles.title}>{t.filter}</h2>

        <CloseButton onClick={onClose} controls={{ id, expanded: isOpen }} />
      </header>
      <div className={clsx(styles.content, 'u-container-width')}>
        {children}
      </div>
      <footer className={clsx(styles.footer, 'u-container-width')}>
        <div className={styles.buttonWrapper}>
          <Button
            className={styles.showResultsButton}
            label={t.showResults}
            onClick={onClose}
            icon="NAV_ARROW_RIGHT"
          />

          <Button
            onClick={onClear}
            label={t.clearFilters}
            hideLabel
            variant="secondary"
            icon="BIN_MINUS_IN"
          />
        </div>
      </footer>
    </Modal>
  );
}
